import { Typography, Tag, Space } from 'antd'
import { MessageProps } from './types'

const Message: React.FC<MessageProps> = ({ recordName, status }) => {
  return (
    <Space direction="vertical" style={{ marginBottom: '24px' }}>
      <Typography.Text>
        During this process <Tag>{recordName}</Tag>will be returned to{' '}
        <Typography.Text>{status}</Typography.Text> and field values will be
        modified.
      </Typography.Text>
      <Typography.Text strong type="warning">
        This action cannot be undone
      </Typography.Text>
    </Space>
  )
}

export default Message
